const pha_clinics = [
  // SURGICAL CLINICS
  { clinic_type: 'Surgical Clinic', clinic_list: [
    { label: 'Anaesthesiology', value: 'Anaesthesiology',
      dates: {
        Monday: { from: '7:00', to: '15:00'},
        Tuesday: { from: '7:00', to: '15:00'},
        Wednesday: { from: '7:00', to: '15:00'},
        Thursday: { from: '7:00', to: '15:00'},
        Friday: { from: '7:00', to: '15:00'},
      }
    },
    { label: 'Gynae/Antenatal - Team B', value: 'Gynae/Antenatal - Team B',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Neurosurgery', value: 'Neurosurgery',
      dates: {
        Monday: { from: '12:00', to: '16:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'General Surgery', value: 'General Surgery',
      dates: {
        Monday: { from: '12:00', to: '16:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '12:00', to: '16:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Gynae/Antenatal Team D', value: 'Gynae/Antenatal Team D',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '8:00', to: '12:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Cardiothoracic', value: 'Cardiothoracic',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '12:00', to: '16:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Gynae/Antenatal Team A', value: 'Gynae/Antenatal Team A',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Urology', value: 'Urology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '12:00', to: '16:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Gynae/Antenatal Team C', value: 'Gynae/Antenatal Team C',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'General Surgery/Vascular', value: 'General Surgery/Vascular',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
    { label: 'Plastics', value: 'Plastics',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '10:00', to: '14:00'},
      }
    },
  ]},

  // Medical Clinics
  { clinic_type: 'Medical Clinic', clinic_list: [
    { label: 'Dermatology', value: 'Dermatology',
      dates: {
        Monday: { from: '9:00', to: '14:00'},
        Tuesday: { from: '9:00', to: '14:00'},
        Wednesday: { from: '9:00', to: '14:00'},
        Thursday: { from: '9:00', to: '14:00'},
        Friday: { from: '9:00', to: '14:00'},
      }
    },
    { label: 'Team D - Medicine', value: 'Team D - Medicine',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Pulmonary', value: 'Pulmonary',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Team C - Medicine', value: 'Team C - Medicine',
      dates: {
        Monday: { from: '12:00', to: '16:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Neurology', value: 'Neurology',
      dates: {
        Monday: { from: '12:00', to: '16:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Team B - Medicine', value: 'Team B - Medicine',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '8:00', to: '12:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Rheumatology', value: 'Rheumatology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '8:00', to: '12:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Team A - Medicine', value: 'Team A - Medicine',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '12:00', to: '16:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'MOH Immunology', value: 'MOH Immunology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Team E - Medicine', value: 'Team E - Medicine',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '12:00', to: '16:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Endocrinology', value: 'Endocrinology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '12:00', to: '16:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Renal', value: 'Renal',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Team F - Medicine', value: 'Team F - Medicine',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Gastrointestinal', value: 'Gastrointestinal',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
    { label: 'Cardiology', value: 'Cardiology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
    { label: 'MOH Chest', value: 'MOH Chest',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '12:00', to: '16:00'},
      }
    },
  ]},

  // Paediatric Clinics
  { clinic_type: 'Paediatric Clinic', clinic_list: [
    { label: 'General Paediatric', value: 'General Paediatric',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Paediatric Asthma', value: 'Paediatric Asthma',
      dates: {
        Monday: { from: '00:00', to: '16:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Sickle Cell', value: 'Sickle Cell',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '00:00', to: '16:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Adult Asthma', value: 'Adult Asthma',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Paediatric ID', value: 'Paediatric ID',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Paediatric Neurodevelopmental Screening', value: 'Paediatric Neurodevelopmental Screening',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '00:00', to: '16:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Neurology Development', value: 'Neurology Development',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '12:00', to: '16:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Neonatology', value: 'Neonatology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
    { label: 'Adolescent Psychiatry (SRC)', value: 'Adolescent Psychiatry',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '12:00', to: '16:00'},
      }
    },
  ]},

  // E.N.T. Clinics
  { clinic_type: 'E.N.T. Clinic', clinic_list: [
    { label: 'ENT', value: 'ENT',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
    { label: 'Theater', value: 'Theater',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '8:00', to: '12:00'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'ENT Review', value: 'ENT Review',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Oncology Review and Radiation', value: 'Oncology Review and Radiation',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
  ]},

  // ORTHOPAEDIC Clinics
  { clinic_type: 'Orthopaedic Clinic', clinic_list: [
    { label: 'Orthopaedic Hand', value: 'Orthopaedic Hand',
      dates: {
        Monday: { from: '8:00', to: '12:00'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Orthopaedic General', value: 'Orthopaedic General',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '7:00', to: '12:00'},
        Wednesday: { from: '8:00', to: '12:00'},
        Thursday: { from: '8:00', to: '12:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Vascular Clinic', value: 'Vascular Clinic',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '8:00', to: '12:00'},
      }
    },
  ]},

  // Oncology Clinics
  { clinic_type: 'Oncology Clinic', clinic_list: [
    { label: 'Medical Oncology', value: 'Medical Oncology',
      dates: {
        Monday: { from: '9:30', to: '13:30'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '10:00', to: '14:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Gynae Oncology', value: 'Gynae Oncology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: '9:30', to: '13:30'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Radiation Oncology', value: 'Radiation Oncology' ,
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: '9:30', to: '13:30'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Palliative/Radiation Oncology', value: 'Palliative/Radiation Oncology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: '10:00', to: '14:00'},
        Friday: { from: 'N/A', to: 'N/A'},
      }
    },
    { label: 'Surgical Oncology', value: 'Surgical Oncology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '9:30', to: '13:30'},
      }
    },
    { label: 'Paediatric Oncology', value: 'Paediatric Oncology',
      dates: {
        Monday: { from: 'N/A', to: 'N/A'},
        Tuesday: { from: 'N/A', to: 'N/A'},
        Wednesday: { from: 'N/A', to: 'N/A'},
        Thursday: { from: 'N/A', to: 'N/A'},
        Friday: { from: '9:30', to: '13:30'},
      }
    },
  ]}
]

export default pha_clinics;
